var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fmcy-branding {\n  width: 100%;\n  text-align: center;\n  margin: auto;\n  cursor: pointer; }\n  .fmcy-branding .fmy-branding-f {\n    background-image: url(" + escape(require("./img/f_logo_white.png")) + ");\n    width: 53px;\n    height: 142px;\n    background-size: contain;\n    background-repeat: no-repeat; }\n  .fmcy-branding .fmy-branding-logo-full {\n    background-image: url(" + escape(require("./img/the_original_farm_logo_white.png")) + ");\n    background: url(" + escape(require("./img/the_original_farm_logo_white.svg")) + "), linear-gradient(transparent, transparent);\n    height: 52px;\n    width: 148px;\n    background-repeat-x: no-repeat;\n    background-repeat-y: no-repeat;\n    background-repeat: no-repeat;\n    background-size: contain; }\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./assets/js/common/farm-branding/farm-branding.scss
 ** module id = 203
 ** module chunks = 1 23 27 28 39 42 62 76 81 89 136
 **/